import React from 'react';
import loadable from '@loadable/component';
import {getProductData} from '../../actions/products'
import queryString from 'query-string';

export default {
	component : loadable(() => import(/* webpackChunkName: "homepage_omni" */'./AddEditProductOmni'),{
		fallback : <div>Loading...</div>
	}),
	clientData: (store,match,location,matchedRoute) => {
		const productId = match.params.productId?match.params.productId:'ADD_PRODUCT';
		const isDuplicate = productId && !matchedRoute.isEditProduct;
		const isTemp = queryString.parse(window.location.search).isTemp;
		const isObjection = queryString.parse(window.location.search).isObjection;
		let id = '';
		if(isObjection){
			id = productId.split('_OBJECTION')[0].split('_')[1];
		}
		
		return store.dispatch(getProductData({
			isDuplicate,
			productId,
			isTemp,
			id
		}));
	}
};